import {
  toString3o7ifthqydp6e as toString,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mbdrkik40uwhqc as Char__compareTo_impl_ypi4mb,
} from '../Char.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../js/charSequenceJs.mjs';
import {
  isLetterImpl3fxxojmw2aa31 as isLetterImpl,
  isLowerCaseImpl3f22xubv8iett as isLowerCaseImpl,
} from './_LetterChars.mjs';
import { isDigitImpl2dyu4v4pv3gqj as isDigitImpl } from './_DigitChars.mjs';
import { isWhitespaceImpl2nyplwp172aso as isWhitespaceImpl } from './_WhitespaceChars.mjs';
import { titlecaseCharImpli42cc4hnceu7 as titlecaseCharImpl } from './_TitlecaseMappings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function uppercaseChar(_this__u8e3s4) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  var uppercase = toString(_this__u8e3s4).toUpperCase();
  return uppercase.length > 1 ? _this__u8e3s4 : charCodeAt(uppercase, 0);
}
function isLowSurrogate(_this__u8e3s4) {
  return _Char___init__impl__6a9atx(56320) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57343) : false;
}
function isHighSurrogate(_this__u8e3s4) {
  return _Char___init__impl__6a9atx(55296) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(56319) : false;
}
function isLetter(_this__u8e3s4) {
  if ((_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) || (_Char___init__impl__6a9atx(65) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(90) : false)) {
    return true;
  }
  if (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(128)) < 0) {
    return false;
  }
  return isLetterImpl(_this__u8e3s4);
}
function isDigit(_this__u8e3s4) {
  if (_Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false) {
    return true;
  }
  if (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(128)) < 0) {
    return false;
  }
  return isDigitImpl(_this__u8e3s4);
}
function isWhitespace(_this__u8e3s4) {
  return isWhitespaceImpl(_this__u8e3s4);
}
function isLetterOrDigit(_this__u8e3s4) {
  if ((_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) || (_Char___init__impl__6a9atx(65) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(90) : false) || (_Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false)) {
    return true;
  }
  if (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(128)) < 0) {
    return false;
  }
  return isDigitImpl(_this__u8e3s4) || isLetterImpl(_this__u8e3s4);
}
function isLowerCase(_this__u8e3s4) {
  if (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) {
    return true;
  }
  if (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(128)) < 0) {
    return false;
  }
  return isLowerCaseImpl(_this__u8e3s4);
}
function titlecaseChar(_this__u8e3s4) {
  return titlecaseCharImpl(_this__u8e3s4);
}
//region block: exports
export {
  isDigit as isDigit3mimrri4wkzop,
  isHighSurrogate as isHighSurrogate11jfjw70ar0zf,
  isLetterOrDigit as isLetterOrDigit2kuxd9e198haf,
  isLetter as isLettere1qnx5bysxbd,
  isLowSurrogate as isLowSurrogateujxcv7hjn4ma,
  isLowerCase as isLowerCase16nv9n55l9laa,
  isWhitespace as isWhitespace25occ8z1ed1s9,
  titlecaseChar as titlecaseChar2jyx3x8hfb89d,
  uppercaseChar as uppercaseChar6lahngw3wvwg,
};
//endregion

//# sourceMappingURL=charJs.mjs.map
